import { AxiosInstance } from '../../helpers/AxiosInstance';
import Config from '../../config';

const CreateTemplate = (tenantId:string,channelId:string,data)=>{
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/template/${tenantId}/3/wb/${channelId}`, data)
}

const whatsappMediaUpload = (channelId:string,data)=>{
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/whatsapp/upload/${channelId}`, data)
}

export const WhatsappService = {
    CreateTemplate,
    whatsappMediaUpload
};